import httpAuth from "@/common/http-common";
import { 
  CommercialParticipantModel
} from "@/views/sidebar/commercial-participant/participant.types";

class CommercialParticipantService {
  async GetCommercialParticipant(clientId: number, participantId: number) {
    const { data } = await httpAuth().get<CommercialParticipantModel[]>(
      '/SummaryDashboard/GetCommercialParticipant', { params: {
        clientId: clientId,
        participantId: participantId
      } 
    });
    return data;
  }

  async UpsertParticipant(commercialParticipantModel: CommercialParticipantModel) {
    const { data } = await httpAuth().post(
      `/SummaryDashboard/UpsertParticipant`, 
      commercialParticipantModel 
    );
    return data;
  }
}

export default new CommercialParticipantService();